import React, { useCallback, useEffect, useRef } from "react";
import { IconButton, Stack } from "@mui/material";
import {
  StyledSelectInput,
  StyledTextInput,
} from "../../../../../../Reuse/FormInput";
import { doorStatus } from "../../../Context";
import { PlusCircleFilled } from "@ant-design/icons";
import { useWatch } from "react-hook-form";
import { DeleteIcon } from "../../../../../../Reuse/Icon";

const width = 150;

const DoorRow = ({
  index,
  control,
  showAuto,
  openPopup,
  setValue,
  setAvailableDoor,
  handleRemoveDoors,
}) => {
  const prevDoorRef = useRef({});
  const door = useWatch({ control, name: `doors.${index}` });
  const handleLabelChange = useCallback((e, onChange) => {
    onChange(e);
  }, []);

  const clearDoorRow = useCallback(() => {
    if (door.device_id && door.isUpdate === false) {
      setAvailableDoor(door.device_id);
    }
    handleRemoveDoors(index);
  }, [handleRemoveDoors, index, door, setAvailableDoor]);

  useEffect(() => {
    if (!door.isUpdate) {
      if (door.id && !prevDoorRef.current?.id) {
        // New door added
        prevDoorRef.current = door;
      } else if (
        prevDoorRef.current?.id &&
        door.device_id !== prevDoorRef.current?.device_id
      ) {
        setAvailableDoor(prevDoorRef.current?.device_id);
        prevDoorRef.current = {};
        setValue(`doors.${index}.id`, "");
      }
    }
  }, [door]);

  return (
    <Stack
      direction={"column"}
      gap={1.5}
      alignItems="flex-start"
      sx={{ width: "100%" }}
    >
      <Stack
        direction="row"
        alignItems="flex-start"
        flexGrow={1}
        gap={0.75}
        sx={{ width: "100%" }}
      >
        <StyledTextInput
          label="Device Id"
          name={`doors.${index}.device_id`}
          sx={{ width, minWidth: width }}
          control={control}
          showError={false}
          placeholder={"-"}
          onChange={handleLabelChange}
        />
        {/* <StyledTextInput
          control={control}
          name={`doors.${index}.display_id`}
          label="Display Id"
          showError={false}
          sx={{ width, minWidth: width }}
          placeholder="-"
          onChange={handleLabelChange}
        /> */}
        <StyledTextInput
          control={control}
          name={`doors.${index}.ip`}
          label="IP"
          showError={false}
          sx={{ width, minWidth: width }}
          placeholder={"-"}
          onChange={handleLabelChange}
        />
        <StyledTextInput
          control={control}
          name={`doors.${index}.port`}
          label="Port"
          showError={false}
          sx={{ width: 100 }}
          placeholder="Port"
          onChange={handleLabelChange}
        />
        <StyledSelectInput
          control={control}
          name={`doors.${index}.status`}
          optionList={doorStatus}
          label="Status"
          showError={false}
          sx={{ width: 100 }}
          onChange={handleLabelChange}
          placeholder={"Select"}
        />
        <Stack
          flexGrow={1}
          direction="row"
          justifyContent="flex-end"
          alignItems="flex-start"
          gap={0}
          sx={{ marginTop: 3.25 }}
        >
          <IconButton
            onClick={clearDoorRow}
            sx={{ color: "#BC1B06", fontSize: 18 }}
          >
            <DeleteIcon />
          </IconButton>
          <Stack direction="row" flexGrow={1}></Stack>
          {showAuto ? (
            <IconButton
              variant="contained"
              // size="large"
              onClick={(e) => openPopup(e, index, "doors")}
              sx={{ fontSize: 24 }}
            >
              <PlusCircleFilled />
            </IconButton>
          ) : null}
        </Stack>

        {/* <Stack
          // flexGrow={1}
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
        </Stack> */}
        {/* {showAuto || true ? (
          <IconButton
            variant="contained"
            // size="large"
            onClick={(e) => openPopup(e, index, "doors")}
            sx={{ fontSize: 24, marginTop: 3.25 }}
          >
            <PlusCircleFilled />
          </IconButton>
        ) : null} */}
      </Stack>
    </Stack>
  );
};

export default DoorRow;
